import { atom } from 'jotai';
import { isAppModule } from '@src/utils/constants';

const summaryPanelAtom = atom(true);
const metricPanelAtom = atom(true);
const dimensionPanelAtom = atom(true);
const flowToolbarPanelAtom = atom(true);

const panelsAtom = atom((get) => {
  return {
    summary: get(summaryPanelAtom),
    flowToolbar: get(flowToolbarPanelAtom),
    metric: get(metricPanelAtom),
    dimension: get(dimensionPanelAtom),
  };
});

// Store only the KPI ID instead of the full config object
// Default: KPI ID 5 for App/DPI mode (e.g. "Conviva Good"), 1 for other modules
export const currentKpiIdAtom = atom(null);

export { summaryPanelAtom, metricPanelAtom, dimensionPanelAtom, flowToolbarPanelAtom, panelsAtom };
